import { defineStore } from "pinia";

type ConfigStore = {
    standardLifeProcessingDelayBannerEnabled: boolean,
    apiUrl: string,
    sentryDsn: string,
    sessionTimeoutPage: number,
    sessionTimeoutWarning: number,
    cdnUrl: string,
    toastTimeout: number,
    pollTimeout: number,
    pollFrequency: number,
    getAddressBaseURL: string,
    getAddressKey: string,
    sessionCookieKey: string,
    maintenanceMode: boolean,
    extranetHandoff: boolean,
}

export const useConfigStore = defineStore("config", {
    state: () : ConfigStore => {
        return {
            standardLifeProcessingDelayBannerEnabled: false,
            apiUrl: "",
            sentryDsn: "",
            sessionTimeoutWarning: 0,
            sessionTimeoutPage: 0,
            cdnUrl: "",
            toastTimeout: 0,
            pollTimeout: 0,
            pollFrequency: 0,
            getAddressBaseURL: "",
            getAddressKey: "",
            sessionCookieKey: "JSESSIONID",
            maintenanceMode: false,
            extranetHandoff: false,
        };
    },
    actions: {
        initialise(config : {
            standardLifeProcessingDelayBannerEnabled: boolean,
            quoteApiUrl: string,
            sentryDsn: string,
            sessionTimeoutPage: number,
            sessionTimeoutWarning: number,
            toastTimeout: number,
            pollTimeout: number,
            pollFrequency: number,
            cdnUrl: string,
            getAddressBaseURL: string,
            getAddressKey: string,
            sessionCookieKey: string,
            maintenanceMode: boolean,
        }) {
            this.standardLifeProcessingDelayBannerEnabled = config.standardLifeProcessingDelayBannerEnabled;
            this.apiUrl = config.quoteApiUrl;
            this.sentryDsn = config.sentryDsn;
            this.sessionTimeoutWarning = config.sessionTimeoutWarning;
            this.sessionTimeoutPage = config.sessionTimeoutPage;
            this.cdnUrl = config.cdnUrl;
            this.toastTimeout = config.toastTimeout;
            this.pollTimeout = config.pollTimeout;
            this.pollFrequency = config.pollFrequency;
            this.getAddressBaseURL = config.getAddressBaseURL;
            this.getAddressKey = config.getAddressKey;
            this.sessionCookieKey = config.sessionCookieKey;
            this.maintenanceMode = config.maintenanceMode;
        },
    },
});
